export enum FontFamily {
	BasisGrotesque = `'Basis Grotesque Pro', -apple-system, BlinkMacSystemFont,
    'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Roboto,
    sans-serif`
}
